var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_Dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.812,
    height: 16.022,
    viewBox: "0 0 25.812 16.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 12",
    d: "M34.142,27.341a2.676,2.676,0,1,0-2.329-1.369l-3.032,3.46a2.65,2.65,0,0,0-2.735.469L22.7,28.01a2.669,2.669,0,1,0-4.928.919l-3.2,3.912a2.68,2.68,0,1,0,1.379,1.127l3.183-3.9a2.644,2.644,0,0,0,2.7-.5l3.336,1.883a2.669,2.669,0,1,0,4.953-.847l3.028-3.456A2.653,2.653,0,0,0,34.142,27.341Zm0-3.56a.89.89,0,1,1-.89.89A.891.891,0,0,1,34.142,23.78ZM13.67,36.241a.89.89,0,1,1,.89-.89A.891.891,0,0,1,13.67,36.241Zm6.394-7.778a.89.89,0,1,1,.89-.89A.891.891,0,0,1,20.064,28.463ZM27.8,32.8a.89.89,0,1,1,.89-.89A.891.891,0,0,1,27.8,32.8Z",
    transform: "translate(-11 -22)",
    fill: "#92929d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.0c19ac65.svg";
export { ForwardRef as ReactComponent };